module.exports = __webpack_public_path__ + "img/dproxy-price.f1de028b.svg";